//new changes of Navbar//
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { INDUSTRIES_NAV_LINKS, SOLUTIONS_NAV_LINKS } from 'utils/Navbarutils';

const ServiceDropdown = ({ toggleMenu }) => {
  const [isServiceDropdownOpen, setIsServiceDropdownOpen] = useState(false);
  const [isMobileDropdownOpen, setIsMobileDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [isMobileMode, setIsMobileMode] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(null);

  const handleMouseEnter = () => {
    if (!isMobileMode) {
      setIsServiceDropdownOpen(true);
    }
  };

  const handleMouseLeave = () => {
    if (!isMobileMode) {
      setIsServiceDropdownOpen(false);
    }
  };

  const handleSubmenuToggle = (submenu) => {
    setActiveSubmenu((prevmenu) => prevmenu === submenu ? null : submenu);
  };

  //close all the navs once some link is clicked
  const handleNavigationclose = () => {
    setIsServiceDropdownOpen(false); //close the dropdown once we click on any link -> this line is used when in desktop mode
    if (isMobileMode) toggleMenu();  //this line closes the hamburger menu when we are in mobile mode 
  };

  const handleServiceClick = () => {
    setActiveSubmenu("");
    if (isMobileMode) {
      setIsMobileDropdownOpen(!isMobileDropdownOpen);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileMode(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Set initial value

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsMobileDropdownOpen(false);
      }
    };

    if (isMobileDropdownOpen) {
      document.addEventListener('click', handleClickOutside);
    } else {
      document.removeEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isMobileDropdownOpen]);

  return (
    <div
      onMouseEnter={() => handleMouseEnter()}
      onMouseLeave={() => handleMouseLeave()}
      ref={dropdownRef}
      className="relative"
    >
      <div className="px-4 py-2 text-white rounded-md cursor-pointer select-none" onClick={handleServiceClick}>
        <span className='flex items-center'>Services&nbsp;<FontAwesomeIcon icon={faAngleDown} /></span>
      </div>

      {/* mobile screens */}
      {(isMobileMode && isMobileDropdownOpen) &&
        <div className="grid w-full grid-cols-1 py-1 px-4 mt-2 border-t-2 border-white-400 bg-black bg-opacity-90 top-20">
          <div className='w-full p-2 text-sm text-left text-white'>
            <ul>
              <li onClick={() => handleSubmenuToggle('solutions')} className='p-2 bg-gray-500 rounded-md cursor-pointer'>Solutions</li>
              {activeSubmenu === 'solutions' && SOLUTIONS_NAV_LINKS?.map(({ id, label, path, navStyles }) => {
                return (
                  <li key={id} className={navStyles}>
                    <Link to={path} onClick={handleNavigationclose} >{label}</Link>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className='w-full p-2 text-sm text-left text-white'>
            <ul>
              <li onClick={() => handleSubmenuToggle('industries')} className='p-2 bg-gray-500 rounded-md hover:bg-gray-400 cursor-pointer'>Industries</li>
              {activeSubmenu === 'industries' && INDUSTRIES_NAV_LINKS?.map(({ id, label, path, navStyles }) => {
                return (
                  <li key={id} className={navStyles}>
                    <Link to={path} onClick={handleNavigationclose} >{label}</Link>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      }

      {/* desktop mode */}
      {(!isMobileMode && isServiceDropdownOpen) &&
        <div className='absolute pt-4 top-8 left-0 min-w-[550px] z-50'>
          <div className='grid grid-cols-12 gap-4 py-4 px-6 border-t-2 border-orange-400 bg-customGray bg-opacity-95 rounded-b-lg shadow-xl'>
            <div className='col-span-6 p-2 text-sm text-left text-white'>
              <ul>
                <li className='p-2 font-bold text-base border-b border-gray-700 mb-2 text-orange-400'>Solutions</li>
                {SOLUTIONS_NAV_LINKS?.map(({ id, label, path, navStyles }) => {
                  return (
                    <li key={id} className="py-1.5 pl-2 rounded hover:bg-blue-500 transition-colors">
                      <Link to={path} onClick={handleNavigationclose} className="block text-white font-normal">{label}</Link>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className='col-span-6 p-2 text-sm text-left text-white'>
              <ul>
                <li className='p-2 font-bold text-base border-b border-gray-700 mb-2 text-orange-400'>Industries</li>
                {INDUSTRIES_NAV_LINKS?.map(({ id, label, path, navStyles }) => {
                  return (
                    <li key={id} className="py-1.5 pl-2 rounded hover:bg-blue-500 transition-colors">
                      <Link to={path} onClick={handleNavigationclose} className="block text-white font-normal">{label}</Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      }

    </div>
  );
};

export default ServiceDropdown;
